export default "__VITE_ASSET__706c62d3__"